import { render } from "./recentOrdersView.vue?vue&type=template&id=9db5400a"
import script from "./recentOrdersView.vue?vue&type=script&lang=js"
export * from "./recentOrdersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__